import { render, staticRenderFns } from "./otherHandleList.vue?vue&type=template&id=6aca114f&scoped=true"
import script from "./otherHandleList.vue?vue&type=script&lang=js"
export * from "./otherHandleList.vue?vue&type=script&lang=js"
import style0 from "./otherHandleList.vue?vue&type=style&index=0&id=6aca114f&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6aca114f",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("G:\\pinmingproject\\suppervision-manager-ui-huangshi\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6aca114f')) {
      api.createRecord('6aca114f', component.options)
    } else {
      api.reload('6aca114f', component.options)
    }
    module.hot.accept("./otherHandleList.vue?vue&type=template&id=6aca114f&scoped=true", function () {
      api.rerender('6aca114f', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/modules/complaintreporting/online/components/otherHandleList.vue"
export default component.exports